import { AuthBoundary } from "./auth/AuthBoundary";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./i18n";
import { PreferencesProvider } from "./preferences/PreferencesProvider";
import { applyPreferences, loadPreferences } from "./preferences/storage";
import "./index.css";

applyPreferences(loadPreferences());

const root = document.getElementById("root");
if (!root) throw new Error("Application root element was not found");

createRoot(root).render(
  <StrictMode>
    <PreferencesProvider>
      <AuthBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthBoundary>
    </PreferencesProvider>
  </StrictMode>,
);
